import axios from './axios';
import axiosForm from './axiosForm';

export const getAPI = async (path: string, token: string = '') => {
  return axios.get(path, { headers: { Authorization: `Bearer ${token}` } });
};

export const postAPI = async (
  path: string,
  data: object,
  token: string = ''
) => {
  return axios.post(
    path,
    { ...data },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

export const patchAPI = async (
  path: string,
  token: string = ''
) => {
  return axios.patch(
    path,
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

export const deleteAPI = async (
  path: string,
  data: object = {data: {}},
  token: string = ''
) => {
  return axios.delete(
    path,
    { data, headers: { Authorization: `Bearer ${token}` } }
  );
};

export const postFormDataAPI = async (path: string, formData: FormData) => {
  return axiosForm.post(path, formData);
};

export const putAPI = async (
  path: string,
  data: object,
  token: string = ''
) => {
  return axios.put(
    path,
    { ...data },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};
